/* Ürün Sekmesi Drawer — yapaycicekal.com (Be Yours 8.4.0) */
(function () {
  if (window.__ycdTabDrawerInit) return;
  window.__ycdTabDrawerInit = true;

  function openDrawer(drawer, trigger) {
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ycd-drawer-open');
    var closeBtn = drawer.querySelector('.ycd-tab-drawer__close');
    requestAnimationFrame(function () { if (closeBtn) closeBtn.focus(); });
  }

  function closeDrawer(drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    var host = drawer.closest('.ycd-tab');
    var trigger = host ? host.querySelector('[data-ycd-tab-open]') : null;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(function () { trigger.focus(); });
    }
    document.body.classList.remove('ycd-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-ycd-tab-open]');
    if (openEl) {
      var host = openEl.closest('.ycd-tab');
      var drawer = host ? host.querySelector('.ycd-tab-drawer') : null;
      if (drawer) { e.preventDefault(); openDrawer(drawer, openEl); }
      return;
    }
    var closeEl = e.target.closest('[data-ycd-tab-close]');
    if (closeEl) {
      var drawerToClose = closeEl.closest('.ycd-tab-drawer');
      if (drawerToClose) { e.preventDefault(); closeDrawer(drawerToClose); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDrawerEl = document.querySelector('.ycd-tab-drawer[aria-hidden="false"]');
    if (openDrawerEl) { e.preventDefault(); closeDrawer(openDrawerEl); }
  });
})();